import { areEqual } from "react-window";
import { IScheduledExport } from "../../../store";
import { SetStateAction } from "react";
import { useScheduledExportsActions } from "../../../actions/scheduled-exports-actions";

export const useScheduledExportHelpers = ({
  setUserCustomerScheduledExports
}: {
  setUserCustomerScheduledExports: React.Dispatch<
    SetStateAction<{
      current: IScheduledExport;
      original: IScheduledExport;
      equals: boolean;
    }>
  >;
}) => {
  const { getUserCustomerScheduledExportsList, updateUserCustomerScheduledExportsEnabled } =
    useScheduledExportsActions();

  //Handles enabled switches
  const handleUserCustomerScheduledExportsEnabled = (key: number, value: boolean) => {
    const replaced = (scheduledExports: IScheduledExport, key: number, value: boolean) => {
      const newItems: IScheduledExport = {
        recurringDay: scheduledExports.recurringDay,
        scheduledExportUserCustomerSettings:
          scheduledExports.scheduledExportUserCustomerSettings &&
          scheduledExports.scheduledExportUserCustomerSettings.map(d =>
            d.scheduledExportId === key ? { ...d, enabled: value } : d
          )
      };
      return newItems;
    };
    setUserCustomerScheduledExports(scheduledExports => ({
      ...scheduledExports,
      current: replaced(scheduledExports.current, key, value),
      equals: areEqual(replaced(scheduledExports.current, key, value), scheduledExports.original)
    }));
  };

  //Handles view changes
  const handleUserCustomerScheduledExportsOptionsChanged = (key: number, value: number[]) => {
    const replaced = (scheduledExports: IScheduledExport, key: number, value: number[]) => {
      const newItems: IScheduledExport = {
        recurringDay: scheduledExports.recurringDay,
        scheduledExportUserCustomerSettings:
          scheduledExports.scheduledExportUserCustomerSettings &&
          scheduledExports.scheduledExportUserCustomerSettings.map(d =>
            d.scheduledExportId === key ? { ...d, selectedViewIds: value } : d
          )
      };
      return newItems;
    };

    setUserCustomerScheduledExports(scheduledExports => ({
      ...scheduledExports,
      current: replaced(scheduledExports.current, key, value),
      equals: areEqual(replaced(scheduledExports.current, key, value), scheduledExports.original)
    }));
  };

  //Handling admin export switch enabled
  const handleUserScheduledExportsEnabled = (customerId: string, value: boolean) => {
    if (customerId) {
      updateUserCustomerScheduledExportsEnabled(customerId, value);
    }
  };

  const getUserCustomerScheduledExports = async (customerId?: string) => {
    if (customerId) {
      const scheduledExports = await getUserCustomerScheduledExportsList(customerId);
      if (scheduledExports)
        setUserCustomerScheduledExports({
          current: scheduledExports,
          original: scheduledExports,
          equals: true
        });
    }
  };

  //Handle if user weekly export checked
  const handleWeeklyChecked = (value: boolean, weekdayValue: number) => {
    const replaced = (scheduledExports: IScheduledExport, value: boolean) => {
      if (scheduledExports) {
        if (value) {
          if (weekdayValue > 1) {
            scheduledExports.recurringDay = weekdayValue;
          } else {
            scheduledExports.recurringDay = 1;
          }
        } else {
          scheduledExports.recurringDay = 0;
        }
      }
      return scheduledExports;
    };
    setUserCustomerScheduledExports(scheduledExports => ({
      ...scheduledExports,
      current: replaced(scheduledExports.current, value),
      equals: areEqual(replaced(scheduledExports.current, value), scheduledExports.original)
    }));
  };

  //Handle user weekday selected
  const handleWeekdaySelected = (value: number) => {
    const replaced = (scheduledExports: IScheduledExport, value: number) => {
      scheduledExports.recurringDay = value;
      return scheduledExports;
    };

    setUserCustomerScheduledExports(scheduledExports => ({
      ...scheduledExports,
      current: replaced(scheduledExports.current, value),
      equals: areEqual(replaced(scheduledExports.current, value), scheduledExports.original)
    }));
  };

  return {
    handleUserCustomerScheduledExportsEnabled,
    handleUserCustomerScheduledExportsOptionsChanged,
    handleUserScheduledExportsEnabled,
    getUserCustomerScheduledExports,
    handleWeeklyChecked,
    handleWeekdaySelected
  };
};
